module.exports = __webpack_public_path__ + "static/media/3DPPA1.419f1e52.jpg";